import { PoolCardHeader, PoolCardQuickActions, PoolImage } from '@synergy/components-next';
import { ReactElement } from 'react';
import { styled } from '@mui/material';

import { ArticleCardFavoriteButton } from '../components/article-card-favorite-button';
import { ArticlePlaceholderImage } from '../../article-placeholder-image/article-placeholder-image';
import { useArticleCardContext } from '../article-card';

const StyledPoolCardHeader = styled(PoolCardHeader)(({ theme }) => ({
    padding: theme.spacing(2),
}));

const StyledPoolCardQuickActions = styled(PoolCardQuickActions)(({ theme }) => ({
    right: 'unset',
    left: theme.spacing(1),
    top: theme.spacing(1),
}));

export const ArticleCardHeader = (): ReactElement => {
    const { article } = useArticleCardContext();

    return (
        <StyledPoolCardHeader>
            {article.previewImage?.['270x270'] ? (
                <PoolImage
                    src={article.previewImage['270x270']}
                    alt={article.name}
                    sx={{
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        objectFit: 'contain',
                        height: '100%',
                        width: '100%',
                        minHeight: 203,
                        maxWidth: 150,
                    }}
                />
            ) : (
                <ArticlePlaceholderImage
                    supplier={article.supplier}
                    imageCachePath="270x270"
                    minHeight={203}
                    maxWidth={150}
                />
            )}

            <StyledPoolCardQuickActions>
                <ArticleCardFavoriteButton />
            </StyledPoolCardQuickActions>
        </StyledPoolCardHeader>
    );
};
